import React from "react";
import "./resources.css";
import Footer from "../Footer";

const DocsGuides = () => {
  return (
    <div className="resource-page">
      <div className="resource-container">
        <h1>Docs & Guides</h1>
        <p className="resource-subtitle">
          Learn how to use KostPadi to manage invoices, customers, accounting,
          inventory, reports, and business records.
        </p>

        <section className="resource-section">
          <h2>Getting Started</h2>
          <div className="resource-grid">
            <div className="resource-card">
              <h3>Create Your Company Profile</h3>
              <p>
                Set up your company information, business name, tax details,
                address, logo, and contact information.
              </p>
            </div>

            <div className="resource-card">
              <h3>Add Customers</h3>
              <p>
                Store customer details for invoices, receipts, payment tracking,
                and customer statements.
              </p>
            </div>

            <div className="resource-card">
              <h3>Create Your First Invoice</h3>
              <p>
                Add line items, VAT, discounts, payment terms, and generate a
                professional PDF invoice.
              </p>
            </div>
          </div>
        </section>

        <section className="resource-section">
          <h2>Accounting Guides</h2>
          <div className="resource-grid">
            <div className="resource-card">
              <h3>Chart of Accounts</h3>
              <p>
                Understand your income, expense, asset, liability, and equity
                accounts.
              </p>
            </div>

            <div className="resource-card">
              <h3>Journal Entries</h3>
              <p>Record accounting entries and keep your books accurate.</p>
            </div>

            <div className="resource-card">
              <h3>Financial Reports</h3>
              <p>
                Generate income statement, balance sheet, cash flow, trial
                balance, and management reports.
              </p>
            </div>
          </div>
        </section>

        <section className="resource-section">
          <h2>Business Tools</h2>
          <div className="resource-grid">
            <div className="resource-card">
              <h3>Inventory Management</h3>
              <p>
                Track stock items, warehouses, movements, valuation, and stock
                ageing.
              </p>
            </div>

            <div className="resource-card">
              <h3>Fixed Assets</h3>
              <p>
                Manage business assets, depreciation, asset categories, and
                asset roll-forward reports.
              </p>
            </div>

            <div className="resource-card">
              <h3>AI Assistant</h3>
              <p>
                Use the KostPadi AI assistant for business, accounting, tax, and
                bookkeeping support. AI responses are informational and should
                not replace professional advice.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default DocsGuides;
